import { dummy_logo } from "../../constant/import";
import { IoCameraOutline } from "react-icons/io5";

function LogoUploader(props: any) {
  const onchange = (event: any) => {
    const files = event.target.files;
    const file = files[0];
    props.hook.setfile(file);

    var img: any = document.getElementById("uploadimg");

    var reader = new FileReader();
    reader.onloadend = function () {
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const onclick = () => {
    var input: any = document.getElementById("imageFile");
    input.click();
  };

  return (
    <div className=" p-1 flex flex-col justify-center items-center ">
      <input
        onChange={(e) => onchange(e)}
        className="hidden"
        id="imageFile"
        type="file"
      />
      <img
        id="uploadimg"
        onClick={onclick}
        className="w-[100px] opacity-50 rounded-[50%]  border-4 border-white shadow "
        src={dummy_logo}
      />
      <p
        onClick={onclick}
        className="bg-[#F6F7FF] w-[130px] rounded-lg cursor-pointer font-semibold text-sm px-3 py-2 text-center mt-2 text-[#293586]"
      >
        <IoCameraOutline size={20} className="inline mr-2 "/>
        Add Logo
      </p>
    </div>
  );
}
export { LogoUploader };
